module.exports = __webpack_public_path__ + "img/logo_GR.e2d42a98.png";